import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OpenStore.css";
import axios from "axios";
import { useToast } from "../../context/ToastContext";
import { InstitutionalContext } from "../../context/InstitutionalContext";
import Modal from 'react-modal';
import { getApiUrl } from "../../config";

const OpenStore = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [hasStore, setHasStore] = useState(false);
  const [storePending, setStorePending] = useState(false); // Başvuru yapıldı ama henüz onaylanmadı
  const [isCheckingStore, setIsCheckingStore] = useState(true);
  const [tcValidationState, setTcValidationState] = useState(''); // '', 'valid', 'invalid'
  const [formData, setFormData] = useState({
    // Adım 1: Mağaza Bilgileri
    magaza_adi: '',

    // Adım 2: Kişisel Bilgiler
    ad: '',
    soyad: '',
    tc: '',
    telefon: '',
    dogum_tarihi: '',
    adres: '',

    // Adım 3: Banka Bilgileri
    banka_adi: '',
    banka_ad_soyad: '',
    banka_iban: '',

    // Sözleşme
    sozlesmeOnay: false,
  });

  const { showToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  // Modal ile ilgili state'ler
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentTerm, setCurrentTerm] = useState('');
  const [termContent, setTermContent] = useState(null);

  // Kuyumcu yazılımı popup state'i
  const [showSoftwarePopup, setShowSoftwarePopup] = useState(true);

  // InstitutionalContext'ten fetchInstitutional fonksiyonunu al
  const { fetchInstitutional } = useContext(InstitutionalContext);

  // Component yüklenirken mağaza kontrolü yap
  useEffect(() => {
    const checkUserStore = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setIsCheckingStore(false);
          return;
        }

        const response = await axios.get(
          `${getApiUrl()}/store-registration/my-store`,
          {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        );

        if (response.data && response.data.store) {
          // Mağaza varsa, aktif mi kontrol et
          if (response.data.store.aktif === 1) {
            setHasStore(true);
          } else {
            // Aktif değilse başvuru yapıldı ama onaylanmadı
            setStorePending(true);
          }
        }
      } catch (error) {
        // Hata varsa mağazası yok olarak kabul et
        console.log('Store check result:', error.response?.status);
      } finally {
        setIsCheckingStore(false);
      }
    };

    checkUserStore();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // TC input için özel validasyon
    if (name === 'tc') {
      if (value.length === 0) {
        setTcValidationState('');
      } else if (value.length === 11) {
        // TC 11 hane olduğunda validasyon yap
        if (validateTCKN(value)) {
          setTcValidationState('valid');
        } else {
          setTcValidationState('invalid');
        }
      } else {
        // Henüz yazılıyor
        setTcValidationState('writing');
      }
    }

    // IBAN input için özel formatlama
    if (name === 'banka_iban') {
      // Sadece büyük harfe çevir ve boşlukları kaldır
      let ibanValue = value.toUpperCase().replace(/\s/g, '');

      // Maksimum 26 karakter
      ibanValue = ibanValue.substring(0, 26);

      // 4'lü gruplara ayır
      const formatted = ibanValue.match(/.{1,4}/g)?.join(' ') || ibanValue;

      setFormData((prevState) => ({
        ...prevState,
        [name]: formatted,
      }));
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };



  const validateTCKN = (tckn) => {
    if (!tckn || tckn.length !== 11 || !/^\d+$/.test(tckn) || tckn[0] === '0') {
      return false;
    }

    let oddSum = 0;
    let evenSum = 0;
    let first10Total = 0;

    for (let i = 0; i < 9; i += 2) {
      oddSum += parseInt(tckn[i]);
    }

    for (let i = 1; i < 9; i += 2) {
      evenSum += parseInt(tckn[i]);
    }

    for (let i = 0; i < 10; i++) {
      first10Total += parseInt(tckn[i]);
    }

    const digit10 = (oddSum * 7 - evenSum) % 10;
    const digit11 = first10Total % 10;

    return digit10 === parseInt(tckn[9]) && digit11 === parseInt(tckn[10]);
  };

  const nextStep = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => Math.min(prev + 1, 3));
    }
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const validateStep = (step) => {
    switch (step) {
      case 1:
        // Giriş kontrolü - ilk adımda
        const token = localStorage.getItem('token');
        if (!token) {
          showToast('Mağaza açmak için önce giriş yapmalısınız', 'error');
          setTimeout(() => {
            navigate('/login');
          }, 2000);
          return false;
        }

        if (!formData.magaza_adi.trim()) {
          showToast('Mağaza adı zorunludur', 'error');
          return false;
        }
        return true;

      case 2:
        if (!formData.ad.trim() || !formData.soyad.trim()) {
          showToast('Ad ve soyad zorunludur', 'error');
          return false;
        }
        if (formData.tc.length !== 11) {
          showToast('TC Kimlik No 11 haneli olmalıdır', 'error');
          return false;
        }
        // TC validasyon kontrolü
        if (!validateTCKN(formData.tc)) {
          showToast('Geçersiz TC Kimlik Numarası', 'error');
          return false;
        }
        if (formData.telefon.length < 10) {
          showToast('Geçerli bir telefon numarası giriniz', 'error');
          return false;
        }
        if (!formData.adres.trim()) {
          showToast('Adres zorunludur', 'error');
          return false;
        }
        return true;



      case 3:
        if (!formData.banka_adi.trim() || !formData.banka_ad_soyad.trim()) {
          showToast('Banka bilgileri zorunludur', 'error');
          return false;
        }
        const iban = formData.banka_iban.replace(/\s/g, '').toUpperCase();
        if (!iban.startsWith('TR') || iban.length !== 26) {
          showToast('Geçerli bir IBAN numarası giriniz (TR ile başlamalı, 26 karakter)', 'error');
          return false;
        }
        if (!formData.sozlesmeOnay) {
          showToast('Sözleşmeyi kabul etmelisiniz', 'error');
          return false;
        }
        return true;

      default:
        return true;
    }
  };

  // Sözleşme içeriğini getirme işlemi
  const getTermsContent = async (sef) => {
    try {
      const content = await fetchInstitutional(sef);

      if (!content || !content.baslik || !content.aciklama) {
        throw new Error('İçerik bulunamadı');
      }

      return (
        <div>
          <h2>{content.baslik}</h2>
          <div dangerouslySetInnerHTML={{ __html: content.aciklama }} />
        </div>
      );
    } catch (error) {
      console.error('Sözleşme içeriği yüklenirken hata oluştu:', error);
      showToast('Sözleşme içeriği yüklenirken bir hata oluştu.', 'error');
      return <div>İçerik yüklenirken bir hata oluştu.</div>;
    }
  };

  // Modal içeriğini yükleme
  useEffect(() => {
    async function loadContent() {
      if (modalIsOpen && currentTerm) {
        const content = await getTermsContent(currentTerm);
        setTermContent(content);
      } else {
        setTermContent(null);
      }
    }
    loadContent();
  }, [modalIsOpen, currentTerm]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateStep(3)) {
      return;
    }

    setIsLoading(true);

    try {
      // Token'ı localStorage'dan al
      const token = localStorage.getItem('token');

      if (!token) {
        showToast('Lütfen önce giriş yapınız', 'error');
        navigate('/login');
        return;
      }

      // İlk olarak mağazayı oluştur
      const submitData = {
        magaza_adi: formData.magaza_adi,
        ad: formData.ad,
        soyad: formData.soyad,
        tc: formData.tc,
        telefon: formData.telefon,
        adres: formData.adres,
        banka_adi: formData.banka_adi,
        banka_ad_soyad: formData.banka_ad_soyad,
        banka_iban: formData.banka_iban.replace(/\s/g, '').toUpperCase(),
        dogum_tarihi: formData.dogum_tarihi,
        komisyon: 10,
        urun_limiti: 50
      };

      const response = await axios.post(
        `${getApiUrl()}/store-registration`,
        submitData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success) {

        // Cache'i yenile (mağazalar anasayfada görünsün)
        try {
          await axios.post(
            `${getApiUrl()}/cache/refresh`,
            {},
            {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            }
          );
        } catch (cacheError) {
          console.log('Cache refresh not critical:', cacheError);
          // Cache yenileme hatası kritik değil, devam et
        }

        // Mağaza başvurusu yapıldı ama henüz aktif değil
        localStorage.setItem('hasActiveStore', 'false');

        showToast('Mağaza başvurunuz başarıyla alınmıştır!', 'success');
        setStorePending(true);
      } else {
        showToast(response.data.error || 'Bir hata oluştu', 'error');
      }

    } catch (error) {
      console.error('Store registration error:', error);
      if (error.response?.data?.error) {
        showToast(error.response.data.error, 'error');
      } else if (error.response?.status === 401) {
        showToast('Oturum süreniz dolmuş. Lütfen tekrar giriş yapınız.', 'error');
        navigate('/login');
      } else {
        showToast('Mağaza oluşturulurken bir hata oluştu', 'error');
      }
    } finally {
      setIsLoading(false);
    }
  };


  const renderStepIndicator = () => {
    const steps = [
      { num: 1, title: 'Mağaza' },
      { num: 2, title: 'Kişisel' },
      { num: 3, title: 'Banka' }
    ];

    return (
      <div className="step-indicator">
        {steps.map((step, index) => (
          <React.Fragment key={step.num}>
            <div className={`step-item ${currentStep >= step.num ? 'active' : ''} ${currentStep === step.num ? 'current' : ''}`}>
              <div className="step-number">{step.num}</div>
              <div className="step-title">{step.title}</div>
            </div>
            {index < steps.length - 1 && (
              <div className={`step-line ${currentStep > step.num ? 'active' : ''}`}></div>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const renderStep1 = () => (
    <div className="form-step">
      <h3 className="step-heading">Mağaza Bilgileri</h3>
      <div className="form-row">
        <label htmlFor="magaza_adi">Mağaza Adı *</label>
        <input
          type="text"
          id="magaza_adi"
          name="magaza_adi"
          value={formData.magaza_adi}
          onChange={handleChange}
          required
        />
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div className="form-step">
      <h3 className="step-heading">Kişisel Bilgiler</h3>
      <div className="form-row-group">
        <div className="form-row">
          <label htmlFor="ad">Ad *</label>
          <input
            type="text"
            id="ad"
            name="ad"
            placeholder="Adınız"
            value={formData.ad}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-row">
          <label htmlFor="soyad">Soyad *</label>
          <input
            type="text"
            id="soyad"
            name="soyad"
            placeholder="Soyadınız"
            value={formData.soyad}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="form-row-group">
        <div className="form-row">
          <label htmlFor="tc">TC Kimlik No *</label>
          <input
            type="text"
            id="tc"
            name="tc"
            placeholder="11 haneli TC No"
            value={formData.tc}
            onChange={handleChange}
            maxLength="11"
            className={
              tcValidationState === 'valid' ? 'border-success' :
                tcValidationState === 'invalid' ? 'border-danger' :
                  tcValidationState === 'writing' ? 'border-warning' : ''
            }
            style={{
              borderWidth: tcValidationState ? '2px' : '1px',
              borderStyle: 'solid'
            }}
            required
          />
          {tcValidationState === 'valid' && (
            <small className="text-success">✓ Geçerli TC Kimlik No</small>
          )}
          {tcValidationState === 'invalid' && (
            <small className="text-danger">✗ Geçersiz TC Kimlik No</small>
          )}
        </div>
        <div className="form-row">
          <label htmlFor="telefon">Telefon *</label>
          <input
            type="tel"
            id="telefon"
            name="telefon"
            placeholder="05XX XXX XX XX"
            value={formData.telefon}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="form-row">
        <label htmlFor="dogum_tarihi">Doğum Tarihi</label>
        <input
          type="date"
          id="dogum_tarihi"
          name="dogum_tarihi"
          value={formData.dogum_tarihi}
          onChange={handleChange}
        />
      </div>
      <div className="form-row">
        <label htmlFor="adres">Adres *</label>
        <textarea
          id="adres"
          name="adres"
          placeholder="Açık adresiniz"
          value={formData.adres}
          onChange={handleChange}
          rows="3"
          required
        />
      </div>
    </div>
  );

  const renderStep3 = () => (
    <div className="form-step">
      <h3 className="step-heading">Banka Bilgileri</h3>
      <div className="form-row">
        <label htmlFor="banka_adi">Banka Adı *</label>
        <input
          type="text"
          id="banka_adi"
          name="banka_adi"
          placeholder="Örn: X Bankası"
          value={formData.banka_adi}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-row">
        <label htmlFor="banka_ad_soyad">Hesap Sahibi Ad Soyad *</label>
        <input
          type="text"
          id="banka_ad_soyad"
          name="banka_ad_soyad"
          placeholder="Hesap sahibinin adı soyadı"
          value={formData.banka_ad_soyad}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-row">
        <label htmlFor="banka_iban">IBAN *</label>
        <input
          type="text"
          id="banka_iban"
          name="banka_iban"
          placeholder="TR00 0000 0000 0000 0000 0000 00"
          value={formData.banka_iban}
          onChange={handleChange}
          maxLength="32"
          required
        />
        <small className="form-hint">TR ile başlamalı, 26 karakter olmalıdır</small>
      </div>

      <div className="form-checkbox store-check mt-4">
        <input
          type="checkbox"
          id="sozlesme-onay"
          name="sozlesmeOnay"
          checked={formData.sozlesmeOnay}
          onChange={handleChange}
          required
        />
        <label htmlFor="sozlesme-onay" className="consent-label">
          <a href="#" onClick={(e) => {
            e.preventDefault();
            setCurrentTerm('dijital-magaza-kiralama-sozlesmesi');
            setModalIsOpen(true);
          }}>Dijital Mağaza Kiralama Sözleşmesi</a>'ni okudum ve kabul ediyorum.
        </label>
      </div>
    </div>
  );



  // Yükleme ekranı
  if (isCheckingStore) {
    return (
      <div className="main">
        <div className="form-container mt-md-4 mt-1 p-md-4 p-3" style={{ textAlign: 'center', minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div>
            <div className="spinner" style={{ margin: '0 auto 20px' }}></div>
            <p>Kontrol ediliyor...</p>
          </div>
        </div>
      </div>
    );
  }

  // Zaten mağazası varsa
  if (hasStore) {
    return (
      <div className="main">
        <div className="form-container mt-md-4 mt-1 p-md-4 p-3">
          <div className="form-header" style={{ textAlign: 'center' }}>
            <h2>Zaten bir mağazanız var</h2>
            <p>Bir kullanıcı sadece bir mağazaya sahip olabilir</p>
          </div>
          <div style={{
            backgroundColor: '#f0f8ff',
            border: '2px solid #425A8B',
            borderRadius: '10px',
            padding: '30px',
            textAlign: 'center',
            marginTop: '30px'
          }}>
            <p style={{ fontSize: '18px', marginBottom: '20px' }}>Mağaza yönetiminize gitmek için aşağıdaki linke tıklayabilirsiniz.</p>
            <button
              onClick={() => navigate('/magaza/')}
              style={{
                backgroundColor: '#425A8B',
                color: 'white',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '5px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'background-color 0.3s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#2d3d5e'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#425A8B'}
            >
              Mağaza Paneline Git →
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Başvuru yapıldı ama henüz onaylanmadı
  if (storePending) {
    return (
      <div className="main">
        <div className="form-container mt-md-4 mt-1 p-md-4 p-3">
          <div className="form-header" style={{ textAlign: 'center' }}>
            <h2>Başvurunuz Alınmıştır</h2>
            <p>Mağaza başvurunuz başarıyla oluşturulmuştur</p>
          </div>
          <div style={{
            backgroundColor: '#f0f9ff',
            border: '2px solid #17a2b8',
            borderRadius: '10px',
            padding: '30px',
            textAlign: 'center',
            marginTop: '30px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
            <p style={{ fontSize: '18px', marginBottom: '20px', color: '#333' }}>
              Başvurunuz incelenmektedir. Onay sürecini tamamlandığında mağaza paneline erişim sağlanacaktır.
            </p>
            <button
              onClick={() => navigate('/')}
              className="btn-bikuyum p-2 rounded-2"
            >
              Ana Sayfaya Dön →
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Form
  return (
    <div className="main">
      <div className="form-container mt-md-4 mt-1 p-md-4 p-3">
        <div className="form-header">
          <h2>Mağaza Açma Başvurusu</h2>
          <p>Birkaç adımda mağazanızı oluşturun</p>
        </div>

        {renderStepIndicator()}

        <form className="form-open-store" onSubmit={handleSubmit}>
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && renderStep2()}
          {currentStep === 3 && renderStep3()}

          <div className="form-navigation">
            {currentStep > 1 && (
              <button
                type="button"
                className="btn-prev"
                onClick={prevStep}
                disabled={isLoading}
              >
                ← Geri
              </button>
            )}

            {currentStep < 3 ? (
              <button
                type="button"
                className="btn-next"
                onClick={nextStep}
                disabled={isLoading}
              >
                İleri →
              </button>
            ) : (
              <button
                type="submit"
                className="kayit-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span>
                    İşleniyor...
                  </>
                ) : (
                  'Mağazayı Oluştur'
                )}
              </button>
            )}
          </div>
        </form>

        <div className="form-footer">
          <div className="info-card">
            <h3>Mağaza Açmanın Avantajları</h3>
            <div className="features">
              <div className="feature-item">
                <div className="icon">🔒</div>
                <p>Güvenli Ödeme, Keyifli Alışveriş</p>
              </div>
              <div className="feature-item">
                <div className="icon">🏠</div>
                <p>Ücretsiz ve kolay mağaza açma şansı</p>
              </div>
            </div>
          </div>

          <div className="login-info">
            <p>Zaten bir mağazanız var mı?</p>
            <a href="/login" className="login-link">Buradan giriş yapabilirsiniz →</a>
          </div>
        </div>
      </div>

      {/* Sözleşme Modalı */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => {
          setModalIsOpen(false);
          setCurrentTerm('');
          setTermContent(null);
        }}
        contentLabel="Sözleşme Modal"
        className="Modal"
        overlayClassName="Overlay"
      >
        <button
          className="close-button"
          onClick={() => {
            setModalIsOpen(false);
            setCurrentTerm('');
            setTermContent(null);
          }}
        >
          ×
        </button>
        {termContent || <div>Yükleniyor...</div>}
      </Modal>

    </div>
  );
};
export default OpenStore;
